import {useState} from 'react';
import NormalBtn from '../StockItems/NormalBtn';
import ReactHowler from 'react-howler'
import * as CoreFns from '../utilities/CoreFns';
import * as TreeFunctions from '../utilities/TreeFunctions';

function App(props) {

  var url = props.url;

  const [isPlaying, setIsPlaying] = useState(false);

  var title = 'Play';
  var icon = 'material-symbols:play-arrow';

  if (isPlaying){
    title = 'Pause';
    icon = 'material-symbols:pause-rounded'
  }

  function togglePlay(e){
    setIsPlaying(!isPlaying);
  }

  if (CoreFns.endsWithMpegEtc(url)){
  }else{
    return <center>Url needs to end with .mpeg or .mp3</center>
//    
  }

  var xxx;
  if (url){
    xxx = <ReactHowler src={url} playing={isPlaying}/>
  }

  var copyright;
  var musicOpt = TreeFunctions.musicOptions();
  function copyrightClick(text){
    return function(e){
      window.prompt('Please display the following text inside your dApp', text)
    }
  }

  for (var i = 0; i < musicOpt.length; i++){
    if (url === musicOpt[i].i){
      copyright = <div onClick={copyrightClick(musicOpt[i].c)} style={{cursor:'pointer', textDecoration:'underline'}}>[Show Copyright]</div>
//
      break;
    }
  }


  var txt = 'To use your own music, upload the files to GitHub, click "Raw" and copy the URL of the raw file.'
  return <center>
      {copyright}
      {txt}
      {xxx}
      <NormalBtn icon={icon} title={title} backScreen={true} onClick={togglePlay}/>

      </center>

}
//
//


export default App;
